// A point is an array of two numbers, [x, y]
type Point = [number, number];
// A polygon is an array of points for the shoelace formula
type Polygon = Point[];

export type ShapeCategory = 'Small' | 'Medium' | 'Big';

/**
 * Calculates the area of a polygon using the Shoelace formula.
 * The polygon is an array of points, e.g., [[x1, y1], [x2, y2], ...].
 * @param polygon The polygon to calculate the area of.
 * @returns The area of the polygon.
 */
export function getPolygonArea(polygon: Polygon): number {
    let area = 0;
    const n = polygon.length;

    for (let i = 0; i < n; i++) {
        const j = (i + 1) % n;
        area += polygon[i][0] * polygon[j][1];
        area -= polygon[j][0] * polygon[i][1];
    }

    return Math.abs(area / 2);
}

/**
 * Categorizes a shape based on its area.
 * @param area The area of the shape.
 * @param smallThreshold The upper bound for the 'Small' category.
 * @param mediumThreshold The upper bound for the 'Medium' category.
 * @returns The category of the shape ('Small', 'Medium', or 'Big').
 */
export function getShapeCategory(
    area: number,
    smallThreshold: number,
    mediumThreshold: number
): ShapeCategory {
    if (area <= smallThreshold) {
        return 'Small';
    }
    if (area <= mediumThreshold) {
        return 'Medium';
    }
    return 'Big';
} 